import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js"

export default class extends Controller {
  static targets = ["startDate", "endDate"]

  connect() {
    this.initializeDatePickers()
  }

  initializeDatePickers() {
    const options = {
      locale: French,
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "d/m/Y"
    }

    flatpickr(this.startDateTarget, options)
    flatpickr(this.endDateTarget, options)
  }
}
